module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Database_16"],"path":[{"$":{"d":"M15,3V5c0,1.66-3.13,3-7,3S1,6.66,1,5V3C1,1.35,4.13,0,8,0S15,1.35,15,3ZM8,13.5c-3.67,0-6.67-1.21-7-2.75A1.37,1.37,0,0,0,1,11v2c0,1.66,3.13,3,7,3s7-1.34,7-3V11a1.37,1.37,0,0,0,0-.25C14.67,12.29,11.67,13.5,8,13.5Zm0-4c-3.67,0-6.67-1.21-7-2.75A1.37,1.37,0,0,0,1,7V9c0,1.66,3.13,3,7,3s7-1.34,7-3V7a1.37,1.37,0,0,0,0-.25C14.67,8.29,11.67,9.5,8,9.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Database_16.svg
// module id = v3R/
// module chunks = 1